export const aboutUsBannerContent = (
    <div className='text-2xl'>
      About Us
    </div>
  )